import { IMyBookingsState } from "@/core/interfaces/state/myBookingsState.interface";

const state: IMyBookingsState = {
  flightBookings: {
    count: 0,
    previous: "",
    next: "",
    bookings: [],
  },
  hotelBookings: {
    count: 0,
    previous: "",
    next: "",
    bookings: [],
  },
  tourBookings: {
    count: 0,
    previous: "",
    next: "",
    bookings: [],
  },
  isFetchingHotelBookings: false,
  isDownloadingBrandTicket: false,
  isDownloadingTourVoucher: false,
  isSendingAirlineTicket: false,
  isFetchingFlightBookings: false,
  isFetchingTourBookings: false,
  isDownloadingMBHotelVoucher: false,
  voucherUrl: "",
};

export default state;
